import styled from 'styled-components';

export const Container = styled.div`
  max-height: 100%;
  overflow: auto;
`;
